import {
    WIZARD_EVENTS,
    WIZARD_INTERNAL_DISTRIBUTION,
    WIZARD_OVERVIEW,
    WIZARD_TEST_CHANNELS,
    WIZARD_TEST_DETAILS,
    WIZARD_DISTRIBUTION,
    WIZARD_TEST_PARAMETERS,
} from './consts';
import getCustomSection from './customSectionsConfig';
import { formatItem, formatItemWithChildren } from '../../../utils/wizard';

function getSectionConfig(
    itemKey,
    onNext,
    onBack,
    onDraftClick,
    distributionsData = {},
    submitData = {},
    nestedItems = {}
) {
    return {
        component: getCustomSection(itemKey, onNext, onBack, onDraftClick, distributionsData, submitData),
        itemTitle: `STATIC.PAGES.AUDIENCES.AUDIENCE_AB_TESTING.WIZARD.SECTIONS_LABELS.${itemKey}`,
        nestedItems,
    };
}

const SECTIONS_TREE = (onNext, onBack, onDraftClick, distributionsData, submitData) => {
    return {
        [WIZARD_TEST_DETAILS]: getSectionConfig(
            WIZARD_TEST_DETAILS,
            onNext,
            onBack,
            onDraftClick,
            distributionsData,
            submitData
        ),
        [WIZARD_DISTRIBUTION]: getSectionConfig(
            WIZARD_DISTRIBUTION,
            onNext,
            onBack,
            onDraftClick,
            distributionsData,
            submitData,
            {
                [WIZARD_TEST_CHANNELS]: getSectionConfig(
                    WIZARD_TEST_CHANNELS,
                    onNext,
                    onBack,
                    onDraftClick,
                    distributionsData,
                    submitData
                ),
                [WIZARD_TEST_PARAMETERS]: getSectionConfig(
                    WIZARD_TEST_PARAMETERS,
                    onNext,
                    onBack,
                    onDraftClick,
                    distributionsData,
                    submitData
                ),
                [WIZARD_INTERNAL_DISTRIBUTION]: getSectionConfig(
                    WIZARD_INTERNAL_DISTRIBUTION,
                    onNext,
                    onBack,
                    onDraftClick,
                    distributionsData,
                    submitData
                ),
            }
        ),
        [WIZARD_EVENTS]: getSectionConfig(WIZARD_EVENTS, onNext, onBack, onDraftClick, distributionsData, submitData),
        [WIZARD_OVERVIEW]: getSectionConfig(
            WIZARD_OVERVIEW,
            onNext,
            onBack,
            onDraftClick,
            distributionsData,
            submitData
        ),
    };
};

export const getRequiredFieldsForStep = stepKey => {
    switch (stepKey) {
        case WIZARD_TEST_DETAILS:
            return ['testName', 'appsite', 'segment'];
        case WIZARD_TEST_CHANNELS:
            return ['testChannels'];
        default:
            return [];
    }
};

const getSectionsListItems = (onNext, onBack, onDraftClick, distributionsData, submitData, disabledItems) => {
    const rawItems = SECTIONS_TREE(onNext, onBack, onDraftClick, distributionsData, submitData) || {};

    return Object.fromEntries(
        Object.entries(rawItems).map(([key, item]) => [
            key,
            item.hasOwnProperty('nestedItems')
                ? formatItemWithChildren(
                      item,
                      disabledItems.includes(key),
                      [WIZARD_INTERNAL_DISTRIBUTION, WIZARD_TEST_PARAMETERS].filter(e => disabledItems.includes(e))
                  )
                : formatItem(item, disabledItems.includes(key)),
        ])
    );
};

export { getSectionsListItems };
